import { render, staticRenderFns } from "./CarouselSection.vue?vue&type=template&id=46b5a938&scoped=true"
import script from "./CarouselSection.vue?vue&type=script&lang=ts"
export * from "./CarouselSection.vue?vue&type=script&lang=ts"
import style0 from "./CarouselSection.vue?vue&type=style&index=0&id=46b5a938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5a938",
  null
  
)

export default component.exports